<script setup lang="ts">
import { ref } from 'vue'
import { useStore } from '@/core/store'
import { useRouter } from 'vue-router'
import { handleError } from '@/utils/ErrorHandler'
import { flashMessage } from '@/utils/FlashMessages'
import TextInput from '@/components/input/TextInput.vue'
import PasswordInput from '@/components/input/PasswordInput.vue'

const email = ref('')
const password = ref('')

const store = useStore()
const router = useRouter()

const validate: () => boolean = () => {
  return true
}

const submit = () => {
  if (validate()) {
    store
      .login(email.value, password.value)
      .then(() => {
        router.push({ name: 'dashboard' })
        flashMessage.success('You are now logged in.')
      })
      .catch(handleError)
  }
}
</script>

<template>
  <div class="container" @keydown.enter="submit">
    <form novalidate>
      <h3>Login</h3>

      <div class="form-group">
        <TextInput v-model="email" :name="'email'" :id="'email'" :placeholder="'Email'" :type="'email'" :required="true" />
        <div class="password-wrapper">
          <PasswordInput v-model="password" :name="'password'" :id="'password'" :placeholder="'Password'" :required="true" />
          <router-link id="forgot-password-link" to="/forgot-password">Forgot password?</router-link>
        </div>
      </div>

      <button class="submit-button" type="button" @click="submit">Login</button>
    </form>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/styles/input.scss';
@import '@/assets/styles/form.scss';

.password-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: stretch;

  #forgot-password-link {
    padding-left: 0.5rem;
    font-size: 0.8rem;
    color: #2253a0;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
